import { fetchDataElementData } from "../../helpers/data-catalogue-api"
import { trapFocus } from "../../helpers/trapFocus"

const closeBtn = document.getElementById("closeDrawerBtn")
const drawerOverlay = document.getElementById("drawerOverlay")
const drawerPanel = document.getElementById("drawerPanel")
const drawerBackdrop = document.getElementById("drawerBackdrop")
const header = document.querySelector(".header")

// Drawer content elements
const drawerVariableName = document.getElementById("drawerVariableName")
const drawerVariableDescription = document.getElementById("drawerVariableDescription")
const drawerDescriptionContainer = document.getElementById("drawerDescriptionContainer")
const drawerVariableDataType = document.getElementById("drawerVariableDataType")
const drawerDataTypeContainer = document.getElementById("drawerDataTypeContainer")
const factorsPanel = document.getElementById("factorsPanel")

// API Configuration

function updateDrawerPosition() {
    if (header) {
        const headerHeight = header.offsetHeight
        drawerOverlay.style.top = `${headerHeight}px`
        drawerOverlay.style.height = `calc(100vh - ${headerHeight}px)`
    }
}

function openDrawer() {
    updateDrawerPosition()
    drawerOverlay.classList.remove("hidden")
    drawerPanel.classList.remove("translate-x-full")
    drawerPanel.classList.add("translate-x-0")
    document.body.style.overflow = "hidden"
    closeBtn?.focus()
    trapFocus(drawerPanel)
}

function updateFactorsPane(variableData) {
    const enumerations =
        variableData?.dataType?.enumerations && variableData.dataType.enumerations.length > 0
            ? generateFactorsTable(variableData)
            : '<p class="mt-1 text-sm text-gray-600">Not applicable</p>'

    factorsPanel.innerHTML = enumerations
}

function generateFactorsTable(variableData) {
    return `<table class="w-full border-collapse">
<thead>
    <tr>
        <th class="bg-blue-300 first:border-l last:border-r border-r-0 px-[12px] py-[10px] ">
            Value
        </th>
        <th class="bg-blue-300 first:border-l last:border-r border-r-0 px-[12px] py-[10px]">
            Value description
        </th>
    </tr>
</thead>
<tbody class="font-roboto">
${variableData.dataType.enumerations
    .map((enumValue) => generateFactorsItem(enumValue.name, enumValue.description))
    .join("")}
</tbody>
</table>`
}

function generateFactorsItem(name, description) {
    return `<tr>
        <td class="">
            ${name ?? ""}
        </td>
        <td class="">
            ${description ?? ""}
        </td>
    </tr>`
}

function updateDetailsPane(tableRow) {
    const name = tableRow.querySelector("[data-name]")?.dataset.name || ""

    const description = tableRow.querySelector("[data-description]")?.dataset.description || ""
    const dataType = tableRow.querySelector("[data-type]")?.dataset.type || ""

    drawerVariableName.textContent = name || ""

    if (dataType) {
        drawerVariableDataType.textContent = dataType
        drawerDataTypeContainer.style.display = "block"
    } else {
        drawerDataTypeContainer.style.display = "none"
    }

    if (description) {
        drawerVariableDescription.innerHTML = description
            .replaceAll("\n", "<br>")
            .replaceAll("* ", "• ")
        drawerDescriptionContainer.style.display = "block"
    } else {
        drawerDescriptionContainer.style.display = "none"
    }
}

function switchTab(activeTab, inactiveTab, activePanel, inactivePanel) {
    // Active tab styles
    activeTab.classList.remove("border-transparent", "hover:text-gray-700")
    activeTab.classList.add(
        "border-green-600",
        "text-green-600",
        "border-t-2",
        "border-l-2",
        "border-r-2",
        "border-b-2",
        "border-b-white",
        "rounded-t-md",
        "-mb-px"
    )
    activeTab.setAttribute("aria-current", "page")

    // Inactive tab styles
    inactiveTab.classList.remove(
        "border-green-600",
        "text-green-600",
        "border-t-2",
        "border-l-2",
        "border-r-2",
        "border-b-2",
        "border-b-white",
        "rounded-t-md",
        "-mb-px"
    )
    inactiveTab.classList.add("border-transparent", "text-gray-500", "hover:text-gray-700")
    inactiveTab.removeAttribute("aria-current")

    activePanel.classList.remove("hidden")
    inactivePanel.classList.add("hidden")
}

function addPanesEvents() {
    const detailsTab = document.getElementById("detailsTab")
    const factorsTab = document.getElementById("factorsTab")
    const detailsPanel = document.getElementById("detailsPanel")

    if (!detailsPanel || !factorsTab || !detailsPanel) return

    detailsTab.addEventListener("click", function () {
        switchTab(detailsTab, factorsTab, detailsPanel, factorsPanel)
    })

    factorsTab.addEventListener("click", function () {
        switchTab(factorsTab, detailsTab, factorsPanel, detailsPanel)
    })
}

function closeDrawer() {
    // Get the stored variableId to restore focus
    const activeElementId = drawerPanel.dataset.activeElementId

    drawerPanel.classList.add("translate-x-full")
    drawerPanel.classList.remove("translate-x-0")
    drawerOverlay.classList.add("hidden")
    document.body.style.overflow = ""
    drawerVariableName.textContent = ""
    drawerVariableDataType.textContent = ""
    drawerVariableDescription.textContent = ""
    factorsPanel.innerHTML = ""

    // Restore focus to the button that opened the drawer
    if (activeElementId) {
        const triggerButton = document.querySelector(
            `#dataDictionaryTable [data-element-id="${activeElementId}"]`
        )
        triggerButton?.focus()
    }

    delete drawerPanel.dataset.activeElementId
}

export function initializeDataDictionaryDrawer() {
    const dataDictionarySection = document.getElementById("data-dictionary-desktop")
    const openBtns = document.querySelectorAll(".openDrawerBtn")
    addPanesEvents()

    if (!dataDictionarySection) return

    openBtns.forEach((btn) => {
        btn.addEventListener("click", async function () {
            const params = new URLSearchParams(window.location.search)

            const originId = params.get("originId")
            const variableId = this.dataset.elementId
            const row = this.closest("tr")

            if (!variableId || !originId) {
                console.error("No variable ID or origin ID found")
                return
            }

            // Show drawer with loading state
            updateDrawerPosition()
            drawerOverlay.classList.remove("hidden")
            drawerPanel.classList.remove("translate-x-full")
            drawerPanel.classList.add("translate-x-0")
            document.body.style.overflow = "hidden"

            // Store the variableId for focus restoration
            drawerPanel.dataset.activeElementId = variableId

            updateDetailsPane(row)

            // Fetch data from API

            try {
                const variableData = await fetchDataElementData(variableId, originId)
                updateFactorsPane(variableData)
            } catch (error) {
                console.error("Error fetching variable data:", error)
            }

            openDrawer()
        })
    })

    closeBtn?.addEventListener("click", closeDrawer)
    drawerBackdrop?.addEventListener("click", closeDrawer)

    document.addEventListener("keydown", (e) => {
        if (e.key === "Escape" && !drawerOverlay.classList.contains("hidden")) {
            closeDrawer()
        }
    })

    let scrollTimeout
    window.addEventListener("scroll", () => {
        if (!drawerOverlay.classList.contains("hidden")) {
            clearTimeout(scrollTimeout)
            scrollTimeout = setTimeout(updateDrawerPosition, 50)
        }
    })

    window.addEventListener("resize", () => {
        if (!drawerOverlay.classList.contains("hidden")) {
            updateDrawerPosition()
        }
    })
}
